import { Component, OnInit } from "@angular/core";
import { Constants } from "src/app/app.constants";
import { StorageService } from "src/app/app.storage.service";

declare var $: any;
@Component({
    selector: 'app-field-user',
    templateUrl: './field-user.component.html',
    styleUrls: ['./field-user.component.css']
  })
  export class FieldUserComponent implements OnInit {
  
    constructor(private storageService: StorageService) { }
  
    userName: string = null;
    profilePic: string = null;
    imageViewUrl: string = Constants.IMAGE_BASE_URL;
    count: number = 1;
    interval: any;
    inAppOsType: string = null;
    inAppOsTypeMap: any = Constants.IN_APP_OS_TYPE_MAP;

    ngOnInit(): void {
      
      this.inAppOsType = this.storageService.getDataFromLocalStorage("inAppOsType");
      let newUserInfo = this.storageService.getDataFromLocalStorage("newUserInfo");
      if(newUserInfo){
        this.userName = newUserInfo.name;
        this.profilePic = newUserInfo.profile;
      }

      this.interval = setInterval(()=>{
        if(this.count == 6){
          this.count = 0;
        }
        this.count++;
      }, 3 * 1000)

    }

    ngAfterContentInit(){
      $(".content").mCustomScrollbar();
    }

    ngOnDestroy(){
      if(this.interval){
        clearInterval(this.interval);
      }
    }

    toLogin(){
      this.storageService.clearStorage();
        window.location.href = Constants.LOGIN_URL;
    }

    stopNavigation(count){
      this.count = count
      // if(this.interval){
      //   clearInterval(this.interval);
      // }
      
    }

    pauseInterval(){
      if(this.interval){
        clearInterval(this.interval);
      }
    }

    startInterval(){
      this.interval = setInterval(()=>{
        if(this.count == 6){
          this.count = 0;
        }
        this.count++;
      }, 3 * 1000)
    }
  
  }
  